export default "__VITE_ASSET__kobm9Rvy__"